// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__k-Uk-","buttons":"Footer_buttons__1HFqW"};